import angular from 'angular';
angular.module('commonServices').filter('joinBy', function() {
  return function(input, delimiter, ignoreEmpty) {
    if (ignoreEmpty)
      return (input || [])
        .filter(function(val) {
          return !!val;
        })
        .join(delimiter || ', ');
    return (input || []).join(delimiter || ', ');
  };
});
